// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-2FgxC";
var _3 = "tabs-Y5wUT";
var _4 = "tabLabel-iMnm9";
var _5 = "tabSelected-1KiXr";
var _6 = "indicator-1_wxW";
var _7 = "tabs__container-3I-kQ";
export { _1 as "__esModule", _2 as "container", _3 as "tabs", _4 as "tabLabel", _5 as "tabSelected", _6 as "indicator", _7 as "tabs__container" }
export default { "__esModule": _1, "container": _2, "tabs": _3, "tabLabel": _4, "tabSelected": _5, "indicator": _6, "tabs__container": _7 }
